import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useFetch, usePromise } from '@rad/hooks';
import { getPublicTour, getTour } from '../../../../common/network/tour';
import { tourThemeOf } from '../../../../theme/tour';
import { useTourTheme } from '../../../../hooks/useTourTheme';
import { useTourPreview } from '../../../../hooks/useTourPreview';
import { backToTour } from '../_tour-home';
import TourHomeLoading from './tour-home-loading';
import TourHomeUnavailable from './tour-home-unavailable';
import TourHomeViewLoader from './tour-home-view-loader';
import TourUnavailable from './tour-unavailable';
// Every screen about one home on a tour reads the tour first, to find the home and its place on the
// route, then the parcel the home sits on. The page wears the tour's theme throughout, as the tour's
// own page does. Whoever manages the tour can preview its homes before visitors can: that reads the
// tour through the endpoint that checks their permission, and anyone else gets the public tour.
const TourHomeLoader = (props) => {
    const previewing = useTourPreview();
    const [tourPromise] = useFetch(previewing ? getTour(false, props.id) : getPublicTour(props.id));
    const tour = usePromise(tourPromise);
    const theme = useMemo(() => tour ? tourThemeOf(tour.themeSettings) : null, [tour]);
    useTourTheme(theme);
    if (tour === undefined)
        return _jsx(TourHomeLoading, {});
    if (tour === null)
        return _jsx(TourUnavailable, { id: props.id, previewing: previewing });
    const index = tour.stops.findIndex(s => s.id === props.stopId);
    const stop = tour.stops[index];
    // A house not yet announced keeps its place on the route but has nothing to show.
    if (stop === undefined || stop.title === '') {
        return _jsx(TourHomeUnavailable, Object.assign({ message: "This home has not been announced yet." }, backToTour(tour.id, previewing)));
    }
    // The server names the property, and its address, only once the tour has started.
    const { propertyId, parcelId } = stop;
    if (propertyId === null || parcelId === null) {
        return _jsx(TourHomeUnavailable, Object.assign({ message: "This home opens when the tour begins." }, backToTour(tour.id, previewing)));
    }
    return _jsx(TourHomeViewLoader, { tour: tour, stop: Object.assign(Object.assign({}, stop), { propertyId, parcelId }), index: index, previewing: previewing, children: props.children }, stop.id);
};
export default TourHomeLoader;
